import { FGTextInput } from "nsitools-react";
import * as React from "react";
import * as Yup from "yup";

import { DogChipApi, DogChipDto } from "../../../../../../api";
import { SmallFormGenerator } from "../../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";

export interface IDogChipPanelProps {
  dogId: number;
  dogChipId: number;
  onSaved: () => void;
}

export const DogChipPanel: React.FunctionComponent<IDogChipPanelProps> = ({
  dogId,
  onSaved,
  dogChipId,
}) => {
  const { t } = useTl();
  const api = useApiService(DogChipApi);

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      chipNumber: Yup.string()
        .nullable()
        .required(t(ETLCodes.Required))
        .test(
          "is-equal",
          t(ETLCodes.ChipNumberAlreadyInUse),
          async function (value) {
            if (!value) return true;
            const res = await api.isChipUnique(value, 0);
            return res.value;
          }
        ),
    });
  }, [api, t]);

  const { data, loading, saveItem, saving } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: (currentId = dogChipId) =>
          currentId > 0
            ? api.getChip(currentId)
            : new DogChipDto({ dogId: dogId }).toJSON(),
        saveApiFn: async (d: DogChipDto) => {
          const res = await api.save(d);
          onSaved();
          return res;
        },
        deleteApiFn: (d) => {},
      }),
      [api, dogChipId, dogId, onSaved]
    ),
    [dogChipId]
  );

  return (
    <SmallFormGenerator
      onSubmit={saveItem}
      initialValues={data}
      loading={loading}
      editMode={true}
      validationSchema={FormSchema}
      minLabelWidth={150}
      saving={saving}
      enableDirtyCheck={false}
    >
      <FGTextInput
        label={t(ETLCodes.ChipNumber)}
        name="chipNumber"
        maxLength={15}
      />
    </SmallFormGenerator>
  );
};
